import parseExactKeywordSearch from "./parseExactKeywordSearch";

export const EXACT_KEYWORD_FIELD_ERROR =
  "Fix quotes, and/or, or -exclusions — you need at least one word to include.";

/** Inline TextField error for exact mode; blank and full-text stay quiet. */
export default function getExactKeywordFieldError(
  keywordSearch: string | undefined,
  exactKeywordSearch: boolean,
): string | undefined {
  if (!exactKeywordSearch) {
    return undefined;
  }
  const parsed = parseExactKeywordSearch(keywordSearch ?? "");
  if (parsed.status !== "invalid") {
    return undefined;
  }
  return EXACT_KEYWORD_FIELD_ERROR;
}
